export const METABASE_SITE_URL = 'https://brainhi.metabaseapp.com';

export enum PhoneAction {
  SEARCH_BY_NUMBER = 'SEARCH_BY_NUMBER',
  SET_PHONES = 'SET_PHONES',
  SET_LOADING_PHONES = 'SET_LOADING_PHONES',
  SEARCH_BY_ACCOUNT = 'SEARCH_BY_ACCOUNT',
  SEARCH_BY_CAMPAIGN = 'SEARCH_BY_CAMPAIGN',
  SET_CAMPAIGNS = 'SET_CAMPAIGNS',
  SET_ACCOUNTS = 'SET_ACCOUNTS',
  SET_SELECTED_PHONES = 'SET_SELECTED_PHONES',
  PAGINATE = 'PAGINATE',
  SET_ASSIGN_TO_CAMPAIGN = 'SET_ASSIGN_TO_CAMPAIGN',
  SET_ASSIGN_TO_ACCOUNT = 'SET_ASSIGN_TO_ACCOUNT',
}

export enum LegalEntityAction {
  SEARCH_BY_NAME = 'SEARCH_BY_NAME',
  SET_LEGAL_ENTITIES = 'SET_LEGAL_ENTITIES',
  SET_LOADING_LEGAL_ENTITIES = 'SET_LOADING_LEGAL_ENTITIES',
  SEARCH_BY_ACCOUNT = 'SEARCH_BY_ACCOUNT',
  SET_ACCOUNTS = 'SET_ACCOUNTS',
  PAGINATE = 'PAGINATE',
  SET_SELECTED_LEGAL_ENTITIES = 'SET_SELECTED_LEGAL_ENTITIES',
}

export const BrandIdentityStatus: { [key: number]: string } = {
  0: 'NO_VALUE',
  1: 'SELF_DECLARED',
  2: 'UNVERIFIED',
  3: 'VERIFIED',
  4: 'VETTED_VERIFIED',
};

export enum AutoscalingView {
  PARENT_ACCOUNTS = 'parent',
  SIMPLE_ACCOUNTS = 'account',
}
